import { render, staticRenderFns } from "./BudgetCalculator.vue?vue&type=template&id=12d170fe&"
import script from "./BudgetCalculator.vue?vue&type=script&lang=js&"
export * from "./BudgetCalculator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports